import { useEffect, useState } from 'react';
import { Box, Button } from '../../../../imports/muiImport';
import { useDispatch, useNavigate, useSelector } from '../../../../imports/generalImport';
import { handleAmount } from '../../../../shared/extra';
import { Stack, Typography } from '@mui/material';
import { purchaseProduct } from '../../../../apiCalls/urls/urlFunction';
import { actionNotifier } from '../../../../components/tostify';
import { getUniqueClass, isUserSelectQty } from '../../../../hooks/utilsFn/utilsFn';
import { giftReceiverDetailsValidate } from '../../../../shared/validation';
import { showGiftDesignPanel } from '../../../../store/giftcardDesign/action';
import { calculatePayment, discountCalculate } from '../customPaymentHook';
import ModelLoading from '../../../../ModelLoading';
import PayU from '../../../../assets/PayU.png';
import RazorPay from '../../../../assets/razorpay-logo.svg';
import GuidelinesModel from '../../../../guidelinesModel';
import { ShieldCheckIcon } from 'lucide-react';
import { getCampaignApiPayload } from '../../../../shared/campaignTracker';

// TODO : Check Loading Implemented in this component or not
//  <PaymentProcessLoading open={purchaseLoading} />
function UserPayButton(props) {
  const { isLoggedIn, walletPayment } = props;
  const [netPayOut, setNetPayout] = useState(0);
  const [loading, setLoading] = useState(false);
  const [guidelineModal, setGuidelineModal] = useState(false);

  const DENOMINATION_STORE_DATA = useSelector((state) => state.Denominations?.allData);
  const USER_PROFILE = useSelector((state) => state.UserProfile?.allData);
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const SELECTEDTEMPLATE = useSelector((state) => state.GiftCardDesign);
  const COUPON_STORE_DATA = useSelector((state) => state?.Denominations?.couponData);

  const {
    discount,
    isCashbackProduct,
    rangeDenomination,
    redirection,
    isShowGiftDesignOption,
    productType,
  } = useSelector((state) => state.ProductDetail?.allData || {});

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const trackingData = getCampaignApiPayload();

  const redirectToHome = () => navigate('/login', { replace: true });

  useEffect(() => {
    if (DENOMINATION_STORE_DATA?.length > 0) {
      const calculationResult = calculatePayment(
        DENOMINATION_STORE_DATA,
        discount,
        PRODUCTDETAILS?.isCashbackProduct
      );
      const finalPay = isCashbackProduct
        ? 0
        : discountCalculate(calculationResult?.totalGrossAmt, discount);
      const finalNetPayment = calculationResult?.totalGrossAmt - finalPay;

      if (walletPayment?.isWalletPayment) {
        const netPayWallet = finalNetPayment - USER_PROFILE?.data?.balance;
        setNetPayout(netPayWallet >= 1 ? netPayWallet : 0);
      } else {
        if (rangeDenomination) {
          setNetPayout(finalNetPayment);
        } else {
          setNetPayout(calculationResult?.netPaymentAmt);
        }
      }
    } else {
      setNetPayout(0);
    }
  }, [
    DENOMINATION_STORE_DATA,
    discount,
    walletPayment,
    rangeDenomination,
    USER_PROFILE?.data?.balance,
    isCashbackProduct,
  ]);

  const validateUserPayment = async () => {
    setLoading(true);

    // Redirect to playStore for the purchasing this product
    if (redirection === 'mobile') {
      const playStoreUrl = `https://play.google.com/store/apps/details?id=in.nngift.vouchers&pcampaignid=web_share`;
      window.open(playStoreUrl, '_blank');
      setLoading(false);
      return;
    }

    if (isShowGiftDesignOption && SELECTEDTEMPLATE?.['isUserWantDesignGiftCard']) {
      const validateResponse = await giftReceiverDetailsValidate(
        SELECTEDTEMPLATE?.giftReceiverDetails?.name,
        SELECTEDTEMPLATE?.giftReceiverDetails?.email,
        SELECTEDTEMPLATE?.giftReceiverDetails?.phone
      );

      if (!validateResponse.status) {
        actionNotifier.error('Receiver Detail is Required', {
          position: 'top-right',
          autoClose: 5000,
        });
        dispatch(showGiftDesignPanel(true));
        setLoading(false);
        return;
      }

      if (![0, 1, 2].includes(SELECTEDTEMPLATE.sharePlateform)) {
        actionNotifier.error('Invalid social share platform selected.', {
          position: 'top-right',
          autoClose: 5000,
        });
        dispatch(showGiftDesignPanel(true));
        setLoading(false);
        return;
      }
    }

    if (!DENOMINATION_STORE_DATA?.length > 0) {
      actionNotifier.error('Denomination not found.', {
        position: 'top-right',
        autoClose: 5000,
      });
      setLoading(false);
      return;
    }

    if (DENOMINATION_STORE_DATA?.length > 0) {
      if (!isUserSelectQty(DENOMINATION_STORE_DATA)) {
        actionNotifier.error('Please Select a Denomination.', {
          position: 'top-right',
          autoClose: 5000,
        });

        setLoading(false);
        return;
      }
    }

    // Validate Payment Method
    if (walletPayment?.isWalletPayment) {
      if (USER_PROFILE?.data?.balance <= 0) {
        actionNotifier.error('Insufficient wallet balance.', {
          position: 'top-right',
          autoClose: 5000,
        });
        setLoading(false);
        return;
      }
    }

    if (!PRODUCTDETAILS?.isOldPayUActive) {
      if (Number(PRODUCTDETAILS?.selectedPaymentMethod?.id) === Number(1)) {
        if (PRODUCTDETAILS?.transactionMSG?.length > 0 && !guidelineModal) {
          if (Number(netPayOut) > Number(PRODUCTDETAILS?.transactionLimit)) {
            setGuidelineModal(true);
            setLoading(false);
            return;
          }
        }
      }
    }

    handleUserPayment(
      DENOMINATION_STORE_DATA,
      PRODUCTDETAILS,
      USER_PROFILE,
      walletPayment,
      navigate,
      setLoading,
      dispatch,
      productType,
      SELECTEDTEMPLATE,
      COUPON_STORE_DATA,
      trackingData
    );
  };

  return (
    <Box sx={{ marginTop: '10px', width: '100%', textAlign: 'center' }}>
      <GuidelinesModel
        open={guidelineModal}
        onClose={() => setGuidelineModal(false)}
        onOpen={() => setGuidelineModal(true)}
        limit_transaction_heading={PRODUCTDETAILS?.limit_transaction_heading}
        description={PRODUCTDETAILS?.transactionMSG}
        button_text_upi={PRODUCTDETAILS?.button_text_upi}
        payButtonClick={() => validateUserPayment()}
      />

      {loading && <ModelLoading loadingStatus={loading} />}

      {
        isLoggedIn ?
          (
            <>
              <Button
                disabled={
                  isUserSelectQty(DENOMINATION_STORE_DATA) ?
                    PRODUCTDETAILS?.isOldPayUActive ?
                      false :
                      PRODUCTDETAILS?.isAnyPaymentGatewayActive ?
                        false :
                        true :
                    true
                }
                onClick={validateUserPayment}
                className={getUniqueClass(PRODUCTDETAILS?.id, PRODUCTDETAILS?.title)}
                sx={{
                  mt: 2,
                  backgroundColor: '#000',
                  color: '#fff',
                  minHeight: { xs: '55px', lg: '46px' },
                  height: { xs: 44, lg: 48 }, // ⬅ force height

                  fontSize: { xs: '1.2rem', lg: '1.4rem' },
                  fontWeight: 700,
                  borderRadius: '999px',
                  textTransform: 'none',
                  px: 6,
                  minWidth: { xs: '90%', sm: '360px' }, // 🔥 centered look
                  maxWidth: '420px',
                  mx: 'auto', // ✅ center
                  '&:hover': {
                    backgroundColor: '#000',
                    boxShadow: 6,
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#000',
                    opacity: 0.6,
                    color: '#fff',
                  },
                }}
              >
                Get this card
              </Button>

              <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center" mt={1}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Safe & secure payment
                </Typography>
                <ShieldCheckIcon size={16} />
              </Stack>
            </>
          ) :
          (
            <>
              <Button
                onClick={redirectToHome}
                className={getUniqueClass(PRODUCTDETAILS?.id, PRODUCTDETAILS?.title)}
                sx={{
                  backgroundColor: '#000',
                  color: '#fff',
                  minHeight: { xs: '48px', lg: '40px' },
                  fontSize: { xs: '1.2rem', lg: '1.4rem' },
                  fontWeight: 700,
                  borderRadius: '999px',
                  textTransform: 'none',
                  px: 6,
                  minWidth: { xs: '90%', sm: '360px' },
                  maxWidth: '420px',
                  mx: 'auto', // ✅ center
                  '&:hover': {
                    backgroundColor: '#000',
                    boxShadow: 6,
                  },
                }}
              >
                Login & Pay ₹{handleAmount(netPayOut)}
              </Button>

              <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mt={1}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Safe & secure payment
                </Typography>
                <Box component="img" src={PayU} alt="PayU" sx={{ height: 18 }} />
              </Stack>
            </>
          )
      }
    </Box >
  );
}

const makePurchasePayloadDenomination = (denominations, product) => {
  let data = [];
  for (const iterator of denominations) {
    if (iterator.QUANTITY > 0) {
      const deno = {
        amount: iterator.AMOUNT,
        discount: product?.isCashbackProduct ? 0 : product?.discount,
        quantity: iterator.QUANTITY,
        total: iterator.TOTAL,
        PRODUCTCODE: iterator?.PRODUCT_CODE,
        ProductGuid: iterator?.PRODUCT_GUID,
        product_id: iterator?.PRODUCT_ID,
        subproduct_id: iterator?.SUB_PRODUCT_ID,
        skuID: iterator?.SKU_ID,
      };
      data.push(deno);
    }
  }
  return data;
};

const purchaseApi = async (purchasePayload, setLoading, navigate, dispatch, trackingData) => {
  // Call the purchase api
  const purchaseResponse = await purchaseProduct({ ...purchasePayload, ...trackingData });

  try {
    if (!purchaseResponse?.data?.status) {
      setLoading(false);
      navigate('/profile/order', { replace: true });
    }

    const gatewayValue = purchaseResponse?.data?.data?.gateway;
    const paymentGatewayKey = purchaseResponse?.data?.data?.paymentGateway;
    const redirectUrl = purchaseResponse?.data?.data?.redirectUrl;

    if (gatewayValue) {
      switch (paymentGatewayKey) {
        case 'phonepe':
          if (redirectUrl) {
            window.location.href = redirectUrl;
          } else {
            console.error('No redirect URL found', purchaseResponse);
          }
          break;

        case 'razorpay':
          await payFromRazorPay(purchaseResponse?.data, purchasePayload);
          break;

        case 'payu':
          await startPayU(purchaseResponse?.data, purchasePayload);
          break;

        default:
          setLoading(false);
          navigate('/profile/order', { replace: true });
          break;
      }
    }

    setLoading(false);
    navigate('/profile/order', { replace: true });
  } catch (error) {
    setLoading(false);
    navigate('/profile/order', { replace: true });
  }

  async function startPayU(purchasedItem, payload) {
    try {
      const totalAmount = purchasedItem.totalAmount;
      const name = payload.customerName;
      const email = payload.emailID;
      const mobile = payload.mobileNo;
      const denominations = payload.denominations.map((item) => {
        return {
          ...item,
          amount: parseInt(Math.round(item.amount - (item.amount / 100) * item.discount)),
          total: parseInt(Math.round(item.amount - (item.amount / 100) * item.discount)),
        };
      });

      // It first checks if the required fields (totalAmount, name, mobile, email) are filled. If not, it throws an error.
      if (totalAmount === 0) throw new Error('Please Select Denomination!');
      if (!name) throw new Error('Please Enter Receiver Name!');
      if (!mobile) throw new Error('Please Enter Receiver Mobile!');
      if (!email) throw new Error('Please Enter Receiver Email!');

      // It then sets loading.value to true, indicating that the process has started.

      // A payObject is created
      const payObject = {
        productId: payload.productId,
        walletPayment: payload.walletPayment,
        emailID: email,
        mobileNo: mobile,
        customerName: name,
        newSite: payload.newSite,
        denominations: [...denominations],
        device_type: 0,
      };

      // It then makes an asynchronous API call to placeOrder with payObject as the argument
      const response = await paymentGateway(payObject, purchasedItem);
      const { status, data, message } = response;

      if (!status) throw new Error(message);
      if (data.gateway) {
        // paymentGateway(data)
      } else {
        // $store.dispatch('notify/success', message);
        // $router.push({name: 'reports'})
      }
      // loading.value = true;
    } catch (error) { }
  }

  async function paymentGateway(data, purchase) {
    try {
      const payUObject = { ...data, ...purchase.data.product_info };
      const form = document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('action', 'https://secure.payu.in/_payment');
      form.setAttribute('service_provider', 'payu_paisa');
      form.setAttribute('target', 'payumoney');
      form.setAttribute('target', '_self');

      for (const prop in payUObject) {
        if (payUObject.hasOwnProperty(prop)) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = prop;
          input.value = payUObject[prop];
          form.appendChild(input);
        }
      }

      document.body.appendChild(form);
      form.submit();
    } catch (error) { }
  }

  async function payFromRazorPay(purchasedItem, payload) {
    const name = payload.customerName;
    const email = payload.emailID;
    const mobile = payload.mobileNo;
    let RZPPayload = {};
    const productId = payload.denominations[0]['product_id'];

    if (productId == 860) {
      const line_items_data = () => {
        const lineItems = [];
        payload.denominations.forEach((element) => {
          const obj = {
            type: 'amazon_giftcard',
            sku: 'amazon_shopping_gc',
            variant_id: purchasedItem.data.receipt,
            price: element.total,
            quantity: element.quantity,
          };

          lineItems.push(obj);
        });

        return lineItems;
      };

      // Define Razorpay payload
      RZPPayload = {
        key: process.env.REACT_APP_99GIFT_LIVE_RZPKEY,
        amount: purchasedItem?.data?.totalAmount,
        currency: 'INR',
        name: 'Zpay Solutions Pvt Ltd',
        description: 'Transaction',
        image: 'https://www.99gift.in/static/media/logo.1f56873eb49af1faa202.png',
        order_id: purchasedItem?.data?.razorpay_ordid,
        handler: function (response) {
          // Handle Razor pay Success and failure
          if (response.razorpay_payment_id) {
            actionNotifier.success('Payment was successful!', {
              position: 'top-right',
              autoClose: 5000,
            });
          } else {
            actionNotifier.error('Payment failed. Please try again.', {
              position: 'top-right',
              autoClose: 5000,
            });
          }
          // Redirect on Orders page
          navigate('/profile/order', { replace: true });
          setLoading(false);
        },
        prefill: {
          name: name,
          email: email,
          contact: mobile,
        },
        notes: {
          internal_order_id: purchasedItem?.data?.receipt,
        },
        line_items_total: purchasedItem?.data?.totalAmount,
        line_items: [...line_items_data()],
        customer_details: {
          name: name,
          email: email,
          contact: mobile,
        },
        theme: {
          color: '#3399cc',
        },
        modal: {
          ondismiss: () => {
            actionNotifier.error('Payment was cancelled or failed.', {
              position: 'top-right',
              autoClose: 5000,
            });
            navigate('/profile/order', { replace: true });
            setLoading(false);
          },
        },
      };
    } else {
      // Define Razorpay payload
      RZPPayload = {
        key: process.env.REACT_APP_99GIFT_LIVE_RZPKEY,
        amount: purchasedItem?.data?.totalAmount,
        currency: 'INR',
        name: 'Zpay Solutions Pvt Ltd',
        description: 'Transaction',
        image: 'https://www.99gift.in/static/media/logo.1f56873eb49af1faa202.png',
        order_id: purchasedItem?.data?.razorpay_ordid,
        handler: function (response) {
          // Handle Razor pay Success and failure
          if (response.razorpay_payment_id) {
            actionNotifier.success('Payment was successful!', {
              position: 'top-right',
              autoClose: 5000,
            });
          } else {
            actionNotifier.error('Payment failed. Please try again.', {
              position: 'top-right',
              autoClose: 5000,
            });
          }
          // Redirect on Orders page
          navigate('/profile/order', { replace: true });
          setLoading(false);
        },
        prefill: {
          name: name,
          email: email,
          contact: mobile,
        },
        notes: {
          internal_order_id: purchasedItem?.data?.receipt,
        },
        theme: {
          color: '#3399cc',
        },
        modal: {
          ondismiss: () => {
            actionNotifier.error('Payment was cancelled or failed.', {
              position: 'top-right',
              autoClose: 5000,
            });
            navigate('/profile/order', { replace: true });
            setLoading(false);
          },
        },
      };
    }

    // Initialize Razorpay instance with the provided options
    const rzpInstance = new window.Razorpay(RZPPayload);
    rzpInstance.open();

    // Payment success and failure handling
    rzpInstance.on('payment.failed', function (response) {
      // You can handle failed payments here
      actionNotifier.error('Payment was cancelled or failed.', {
        position: 'top-right',
        autoClose: 5000,
      });
      setLoading(false);
      navigate('/profile/order', { replace: true });
    });
  }
};

function handleUserPayment(
  deno,
  product,
  user,
  wallet,
  navigate,
  setLoading,
  dispatch,
  productType,
  giftDesign,
  couponStore,
  trackingData
) {
  const filteredDeno = makePurchasePayloadDenomination(deno, product);
  const productId = product?.['id'];

  let purchasePayload = {
    customerName: user?.data?.name,
    emailID: user?.data?.email,
    mobileNo: user?.data?.mobile,
    newSite: true,
    payment_mode: product?.payment_methods?.length > 0 ? product?.selectedPaymentMethod?.id : null,
    walletPayment: wallet?.isWalletPayment || false,
    productId,
    device_type: 0,
    denominations: filteredDeno,
  };

  if (couponStore?.couponCode?.length && couponStore?.isCouponApplied) {
    purchasePayload.couponCode = couponStore?.couponCode;
  }

  if (product?.['isShowGiftDesignOption'] && giftDesign?.['isUserWantDesignGiftCard']) {
    purchasePayload.giftReceiverDetails = giftDesign?.['giftReceiverDetails'];
    purchasePayload.sharePlateform = giftDesign?.['sharePlateform'];

    if (giftDesign?.['selectedPost']?.['isTemplate']) {
      purchasePayload.selectedTemplate = {
        predesignSelectedId: giftDesign?.['selectedPost']?.['id'],
        templateURL: null,
      };
    } else {
      purchasePayload.selectedTemplate = {
        predesignSelectedId: null,
        templateURL: giftDesign?.['selectedPost']?.['image'],
      };
    }
  }

  purchaseApi(purchasePayload, setLoading, navigate, dispatch, trackingData);
}

export default UserPayButton;
